import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useFavicon = () => {
  const { data: settings } = useQuery({
    queryKey: ["siteSettings", "favicon"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("site_settings")
        .select("favicon_url")
        .maybeSingle();
      if (error) throw error;
      return data;
    },
    staleTime: 1000 * 60 * 5, // Cache for 5 minutes
  });

  useEffect(() => {
    if (settings?.favicon_url) {
      // Remove existing favicon links
      const existingLinks = document.querySelectorAll("link[rel*='icon']");
      existingLinks.forEach((link) => link.remove());

      // Add new favicon
      const link = document.createElement("link");
      link.rel = "icon";
      link.href = settings.favicon_url;
      document.head.appendChild(link);
    }
  }, [settings?.favicon_url]);

  return settings?.favicon_url;
};
